/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Rechtsform {

    Einzelunternehmer = 'Einzelunternehmer',

    Ag = 'Ag',

    Gbr = 'Gbr',

    Gmbh = 'Gmbh',

    GmbhCoKg = 'GmbhCoKg',

    Kg = 'Kg',

    Ohg = 'Ohg',

    Sonstiges = 'Sonstiges',

    Ug = 'Ug',

    UgCoKg = 'UgCoKg',

    Verein = 'Verein'
}

